/* eslint-disable react/no-this-in-sfc */
import dynamic from 'next/dynamic'
import React from 'react'
import type { Options } from 'highcharts'

const ChartLoader = () => (
  <div className="w-18 h-10 animate-pulse rounded bg-gray-100 " />
)
const DynamicChartWithNoSSR = dynamic(
  () => import('@/stories/components/Common/Charts/Charts'),
  { ssr: false, loading: ChartLoader },
)
export interface GraphProps {
  performanceData: Array<{
    data: Array<{
      value1: number
      value2: number
      title1: string
      title2: string
      as_on: string
    }>
    title: string
  }>
}

const Graph = ({ data }) => {
  const getFinancialOptions = (data?: {
    graphPoints: Array<string>
    graphStrokeColor: string
    graphFillColor?: string
  }) => {
    const financialOptions: Options = {
      chart: {
        height: 40,
        width: 70,
        type: 'area',
      },
      title: {
        text: undefined,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        series: {
          marker: {
            symbol: 'circle',
          },
        },
        area: {
          fillColor: data?.graphFillColor,
        },
      },
      series: [
        {
          type: 'area',
          data: data?.graphPoints,
          color: data?.graphStrokeColor,
          threshold: null,
        },
      ],
      yAxis: {
        visible: false,
      },
      legend: {
        enabled: false,
      },
      xAxis: {
        visible: false,
      },
      tooltip: { enabled: false },
    }
    return financialOptions
  }

  return (
    <div>
      <div
        className={data.className}
        style={{ color: data.textColor, fontWeight: data.style }}
      >
        {data.title}
      </div>

      {!!data?.graphPoints?.length && (
        <div className="flex justify-end">
          <DynamicChartWithNoSSR options={getFinancialOptions(data)} />
        </div>
      )}
    </div>
  )
}

export default Graph
